export default "__VITE_ASSET__Cdhqvu2P__"